import { useHttpsCallable } from "react-firebase-hooks/functions";
import { useState } from "react";
import { functions } from "@poseidon/firebase/firebase";
import { useErrorMessage } from "@poseidon/ui/app/toasts/useErrorMessage";
import { useToastMessage } from "@poseidon/ui/app/toasts/useToastMessage";

export const useCreateCreditCheck = () => {
  const [executeCallable, loading, callableError] = useHttpsCallable(
    functions,
    "createCreditCheck"
  );
  const [complete, setComplete] = useState(false);
  const [funcError, setFuncError] = useState<any>({});
  const { setError } = useErrorMessage();
  const { setToast } = useToastMessage();
  const run = async ({
    sailorId,
    testPersonaName,
  }: {
    sailorId: string;
    testPersonaName?: string;
  }) => {
    try {
      const result: {
        data: {
          success: boolean;
          code: string;
          details: string;
        };
      } = (await executeCallable({
        sailorId,
        ...(testPersonaName ? { testPersonaName } : {}),
      })) as any;

      if (!result?.data?.success) {
        if (result?.data?.code === "invalid-argument") {
          setError("Validation Errors");
          setFuncError(result?.data?.details);
        }

        if (result?.data?.code) {
          setError(result?.data?.details);
        }

        setComplete(false);
        return;
      }

      setComplete(true);
      if (result?.data?.success) {
        setToast("Successfully retrived Credit Check Result");
      }
    } catch (err) {
      console.error(err);
      setComplete(false);
    }
  };
  return {
    run,
    loading,
    validationErrors: funcError.validationIssues, // array of zod validation errors
    error: callableError || funcError,
    success: !loading && !callableError && !funcError && complete,
  };
};
